<template>
  <section>
    <div class="header">
      <ResultCounterComponent @next="next"/>
      <ResultHeaderComponent/>
    </div>
    <ResultBodyComponent/>
  </section>
</template>

<script>
// @ is an alias to /src
import ResultCounterComponent from "@/components/ResultCounter.vue";
import ResultHeaderComponent from "@/components/ResultHeader.vue";
import ResultBodyComponent from "@/components/ResultBody.vue";

export default {
  name: "Result",
  components: {
    ResultCounterComponent,
    ResultHeaderComponent,
    ResultBodyComponent
  },
  methods: {
    next (e) {
      this.$emit('next')
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  position: sticky;
  top: 0;
  z-index: 1;
}
@media #{$mq-md} {
  .header {
    position: relative;
    top: auto;
    z-index: 1;
  }
}
</style>
